
import { singularityStore } from "@/store/store";
import { TreeNode } from "@/types/tree";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class EditImageButton extends Vue {
  @Prop()
  elementId!: TreeNode["id"];

  editIcon() {
    singularityStore.setIconEditorPanelState({
      iconId: this.elementId,
    });
    singularityStore.setSingularityLeftPanel("icon_editor");
  }
}
